<!-- Loading Overlay -->
<app-loading-overlay [show]="isLoading()"/>
<!-- Filters Bar (only if enabled) -->
@if (config().showSearch || config().showAssigneeFilter) {
    <div class="pipeline-summary mb-3">
        <div class="row g-2">
            @if (config().showSearch) {
                <div class="col-12 col-sm-6 col-md">
                    <app-input
                        [ngModel]="searchTerm()"
                        (valueChange)="onSearchChange($event)"
                        placeholder="Buscar empresa..."
                        groupIcon="ti-search"
                        groupIconPosition="left"
                        [debounceTime]="500">
                    </app-input>
                </div>
                <div class="col-12 col-sm-6 col-md">
                    <div class="form-group">
                        <div class="custom-input-group">
                            <span class="custom-input-group-text icon-left">
                                <i class="ti ti-phone"></i>
                            </span>
                            <input type="tel"
                                   class="form-control input-icon-left"
                                   placeholder="Buscar por telefone..."
                                   mask="(00) 00000-0000"
                                   [validation]="false"
                                   [ngModel]="phone()"
                                   (ngModelChange)="onPhoneChange($event)">
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md">
                    <app-input
                        [ngModel]="partnerName()"
                        (valueChange)="onPartnerNameChange($event)"
                        placeholder="Buscar por sócio..."
                        groupIcon="ti-user"
                        groupIconPosition="left"
                        [debounceTime]="500">
                    </app-input>
                </div>
            }
            @if (config().showAssigneeFilter && config().users && config().users!.length > 0) {
                <div class="col-12 col-sm-6 col-md">
                    <app-select
                        [ngModel]="selectedAssignees()"
                        (ngModelChange)="onAssigneeFilterChange($event)"
                        [items]="config().users!"
                        bindLabel="firstName"
                        bindValue="id"
                        [multiple]="true"
                        placeholder="Filtrar por vendedor"
                        [clearable]="true">
                    </app-select>
                </div>
            }
        </div>
    </div>
}
<!-- Kanban Board -->
<div class="kanban-board" cdkDropListGroup cdkScrollable>
    @for (col of columns(); track col.id) {
        <div class="kanban-column" [ngClass]="getColumnColorClass(col.color)">
            <!-- Column Header -->
            <div class="col-header">
                <div class="d-flex align-items-center gap-2">
                    <span class="col-color-dot"></span>
                    <h6 class="mb-0 col-title">{{ col.title }}</h6>
                    <span class="col-count">{{ col.totalItems | number }}</span>
                </div>
                <small class="col-total">{{ col.totalDebtValue | currency:'BRL':'symbol':'1.0-0' }}</small>
            </div>
            <!-- Cards Container -->
            <div class="kanban-cards-container"
                 cdkDropList
                 [cdkDropListData]="col.cards"
                 [id]="col.id"
                 [cdkDropListAutoScrollStep]="25"
                 (cdkDropListDropped)="onDrop($event, col)"
                 (scroll)="onColumnScroll($event, col.status)">
                @if (col.cards.length === 0) {
                    <div class="kanban-empty-state">
                        <i class="ti ti-inbox"></i>
                        <small class="text-muted">Nenhuma empresa</small>
                    </div>
                } @else {
                    @for (card of col.cards; track card.id) {
                        <div class="kanban-card"
                             cdkDrag
                             [cdkDragData]="card"
                             [ngClass]="[getColumnColorClass(col.color), openAssigneeDropdown() === card.id ? 'dropdown-open' : '']"
                             (click)="openTaskDetails(card)">
                            <!-- Company Name -->
                            <h6 class="card-company">{{ card.companyName }}</h6>
                            <!-- Document Number -->
                            <p class="card-status">{{ card.documentNumber | cpfCnpj }}</p>
                            <!-- Footer: Value + Assignee -->
                            <div class="card-footer">
                                <span class="card-value">{{ card.estimatedDebtValue | currency:'BRL':'symbol':'1.0-0' }}</span>

                                <div class="card-meta">
                                    @if (config().allowAssigneeManagement) {
                                        <!-- Assignee Avatar with Dropdown (editable) -->
                                        <div class="assignee-container">
                                            <div class="avatar-circle"
                                                 [ngbTooltip]="card.assignee ? (card.assignee.firstName + ' ' + card.assignee.lastName) : 'Atribuir vendedor'"
                                                 [class.avatar-empty]="!card.assignee"
                                                 (click)="toggleAssigneeDropdown(card.id, $event)">
                                                @if (card.assignee) {
                                                    {{ (card.assignee.firstName + ' ' + card.assignee.lastName) | initials }}
                                                } @else {
                                                    <i class="ti ti-user-plus"></i>
                                                }
                                            </div>

                                            <!-- Inline Dropdown (Trello/Jira style) -->
                                            @if (openAssigneeDropdown() === card.id) {
                                                <div class="assignee-dropdown" (click)="$event.stopPropagation()">
                                                    <div class="assignee-dropdown-header">
                                                        <span>Atribuir vendedor</span>
                                                        <button class="btn-close-dropdown" (click)="closeAssigneeDropdown()">
                                                            <i class="ti ti-x"></i>
                                                        </button>
                                                    </div>
                                                    <div class="assignee-dropdown-body">
                                                        @if (isLoadingUsers()) {
                                                            <div class="text-center py-2">
                                                                <div class="spinner-border spinner-border-sm" role="status"></div>
                                                            </div>
                                                        } @else {
                                                            @if (card.assignee) {
                                                                <button class="assignee-option" (click)="unassignUser(card, $event)">
                                                                    <div class="avatar-circle avatar-empty">
                                                                        <i class="ti ti-user-minus"></i>
                                                                    </div>
                                                                    <span>Remover vendedor</span>
                                                                </button>
                                                                <div class="dropdown-divider"></div>
                                                            }
                                                            @for (user of users(); track user.id) {
                                                                <button class="assignee-option" (click)="assignUserToCard(card, user, $event)">
                                                                    <div class="avatar-circle">
                                                                        {{ user.firstName.charAt(0) }}{{ user.lastName.charAt(0) }}
                                                                    </div>
                                                                    <span>{{ user.firstName }} {{ user.lastName }}</span>
                                                                </button>
                                                            }
                                                            @if (users().length === 0) {
                                                                <div class="text-center text-muted py-2 small">
                                                                    Nenhum vendedor disponível
                                                                </div>
                                                            }
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    } @else if (card.assignee) {
                                        <!-- Read-only assignee display -->
                                        <div class="avatar-circle"
                                             [ngbTooltip]="card.assignee.firstName + ' ' + card.assignee.lastName">
                                            {{ (card.assignee.firstName + ' ' + card.assignee.lastName) | initials }}
                                        </div>
                                    }
                                </div>
                            </div>
                            <!-- Preview durante drag -->
                            <div *cdkDragPreview class="card-preview">
                                <span class="card-preview-name">{{ card.companyName }}</span>
                                <span class="card-preview-value">{{ card.estimatedDebtValue | currency:'BRL':'symbol':'1.0-0' }}</span>
                            </div>
                        </div>
                        <div class="kanban-card kanban-card-placeholder" *cdkDragPlaceholder></div>
                    }
                }

                <!-- Loading indicator for infinite scroll -->
                @if (col.isLoadingMore) {
                    <div class="kanban-loading">
                        <div class="spinner-border spinner-border-sm text-primary" role="status">
                            <span class="visually-hidden">Carregando...</span>
                        </div>
                        <small class="text-muted ms-2">Carregando mais...</small>
                    </div>
                }
            </div>
        </div>
    }
</div>
<!-- Empty State -->
@if (!isLoading() && getTotalCards() === 0) {
    <div class="empty-state-container">
        <app-empty-alert-message
            icon="ti-inbox-off"
            message="Nenhuma tarefa encontrada"
            description="Não há tarefas para exibir no momento.">
        </app-empty-alert-message>
    </div>
}
